import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbCaretDown: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <polygon points='12 15 6 9.04 7.05 8 12 12.9 16.95 8 18 9.04 12 15' />
        </g>
      </svg>
    </>
  );
};
